export const isNonPrimitive = child =>
  !['string', 'number'].includes(typeof child);
